import { Check } from 'lucide-react'
import { ONBOARDING_STEP_DEFINITIONS } from '@/data/onboarding-steps'
import { useOnboarding } from './useOnboarding'
import { cn } from '@/lib/utils'

export function OnboardingProgress() {
  const { state, goToStep } = useOnboarding()

  return (
    <nav aria-label="Onboarding progress" className="flex flex-wrap items-center justify-center gap-y-4">
      {ONBOARDING_STEP_DEFINITIONS.map((step, visualIndex) => {
        const stepIndex = step.index
        const isCompleted = state.completedSteps.has(stepIndex)
        const isCurrent = state.currentStep === stepIndex
        const isAccessible =
          isCompleted || isCurrent || state.completedSteps.has(stepIndex - 1)

        return (
          <div key={step.key} className="flex items-center">
            {visualIndex > 0 && (
              <div
                className={cn(
                  'h-px w-4 sm:w-6',
                  isCompleted || isCurrent ? 'bg-primary-600' : 'bg-gray-200',
                )}
              />
            )}
            <div className="flex flex-col items-center gap-1">
              <button
                type="button"
                onClick={() => isAccessible && goToStep(stepIndex)}
                disabled={!isAccessible}
                aria-current={isCurrent ? 'step' : undefined}
                aria-label={`${step.label}${isCompleted ? ' (completed)' : ''}`}
                className={cn(
                  'flex h-8 w-8 items-center justify-center rounded-full text-sm font-medium transition-colors',
                  isCompleted && 'bg-primary-600 text-white',
                  isCurrent && !isCompleted && 'border-2 border-primary-600 text-primary-600',
                  !isCurrent && !isCompleted && 'border border-gray-300 text-gray-400',
                  isAccessible && 'cursor-pointer hover:bg-primary-50',
                  !isAccessible && 'cursor-not-allowed',
                )}
              >
                {isCompleted ? <Check className="h-4 w-4" /> : visualIndex + 1}
              </button>
              <span
                className={cn(
                  'text-[10px] font-medium whitespace-nowrap sm:text-xs',
                  isCurrent ? 'text-primary-700' : isCompleted ? 'text-slate-600' : 'text-slate-400',
                )}
              >
                {step.label}
              </span>
            </div>
          </div>
        )
      })}
    </nav>
  )
}
